export enum RecommendationId {
  ElectricEfficiencyLow = "electric-efficiency-low",
  ElectricEfficiencyHigh = "electric-efficiency-high",
  GasEfficiencyLow = "gas-efficiency-low",
  GasEfficiencyHigh = "gas-efficiency-high",
  GasolineFleet = "gasoline-fleet",
  DieselFleet = "diesel-fleet",
  GasEfficiencyElectrification = "gas-efficiency-electrification",
  HighElectrification = "high-electrification",
  Scope1Low = "scope-1-low",
  Scope2Low = "scope-2-low",
  HighSolar = "high-solar",
  LowTarget = "low-target",
  EarlyTarget = "early-target",
  UnaddressedEmissions = "unaddressed-emissions",
  HighOffsets = "high-offsets",
  CarbonCaptureIneffective = "carbon-capture-ineffective",
  HighRECs = "high-recs",
  HighPPA = "high-ppa",
  PlanLessThanTarget = "plan-less-than-target",
  PlanGreaterThanTarget = "plan-greater-than-target",
}
